import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  const footerLinks = {
    services: [
      { label: "Property Management", href: "#services" },
      { label: "Tenant Screening", href: "#services" },
      { label: "Maintenance", href: "#services" },
      { label: "Financial Reporting", href: "#services" },
    ],
    areas: [
      { label: "Overland Park", href: "#areas" },
      { label: "Leawood", href: "#areas" },
      { label: "Olathe", href: "#areas" },
      { label: "Shawnee", href: "#areas" },
      { label: "Liberty", href: "#areas" },
      { label: "Kansas City", href: "#areas" },
    ],
    company: [
      { label: "About Us", href: "#" },
      { label: "Testimonials", href: "#testimonials" },
      { label: "Contact", href: "#contact" },
      { label: "Careers", href: "#" },
    ],
  };

  return (
    <footer className="bg-secondary/30 border-t border-border/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand & CTA */}
          <div className="lg:col-span-1">
            <img 
              src="/rently-logo.png" 
              alt="Rently Properties Logo" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-base text-muted-foreground mb-6 leading-relaxed">
              Professional property management in Johnson County, Kansas. Maximize
              your ROI with expert management.
            </p>
            <Button size="lg" className="bg-secondary hover:bg-secondary/90 text-base px-6 py-5 h-auto" asChild>
              <a href="/get-free-analysis">Get Free Analysis</a>
            </Button>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">
              Services
            </h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    data-testid="footer-link"
                    className="text-sm text-muted-foreground hover:text-accent transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas Links */}
          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">
              Service Areas
            </h3>
            <ul className="space-y-2">
              {footerLinks.areas.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    data-testid="footer-link"
                    className="text-sm text-muted-foreground hover:text-accent transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-display font-semibold text-foreground mb-4">
              Contact
            </h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-sm">
                <MapPin className="h-4 w-4 text-accent flex-shrink-0 mt-0.5" />
                <div className="text-muted-foreground">
                  6850 College Blvd
                  <br />
                  Overland Park, KS 66211
                </div>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Phone className="h-4 w-4 text-accent flex-shrink-0" />
                <a
                  href="tel:913.795.1155"
                  className="text-muted-foreground hover:text-accent transition-colors"
                >
                  913.795.1155
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 text-accent flex-shrink-0" />
                <a
                  href="mailto:info@rently.properties"
                  className="text-muted-foreground hover:text-accent transition-colors"
                >
                  info@rently.properties
                </a>
              </div>
            </div>
          </div>
        </div>

        <Separator className="mb-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <div>
            © {new Date().getFullYear()} Rently Property Management. All rights
            reserved.
          </div>
          <div className="flex gap-6">
            <a
              href="#"
              data-testid="footer-link"
              className="hover:text-accent transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              data-testid="footer-link"
              className="hover:text-accent transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
